import { CommonModule } from "@angular/common";
import { Component, OnInit, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { IInvoice } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { CommonComponent } from "../../../../lib/components/index.mjs";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";
import { InvoiceHistoryComponent } from "./invoice-history/invoice-history.component";
import { MostRecentInvoiceComponent } from "./most-recent-invoice/most-recent-invoice.component";

@Component({
  selector: "app-invoices",
  standalone: true,
  imports: [
    CommonModule,
    BlockUIModule,
    InvoiceHistoryComponent,
    MostRecentInvoiceComponent,
  ],
  templateUrl: "./invoices.component.html",
  styleUrl: "./invoices.component.scss",
})
export class InvoicesComponent extends CommonComponent implements OnInit {
  invoices = signal<IInvoice[] | undefined>(undefined);

  latest_invoice = signal<IInvoice | undefined>(undefined);

  constructor(
    private customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) {
    super();
  }

  newestInvoice() : IInvoice | undefined {
    const sortedInvoices = this.invoices()?.sort((a, b) => b.createdAt - a.createdAt);
    return sortedInvoices![0];
  }

  ngOnInit(): void {
    this.isLoading(true);

    this.authService.user$.subscribe(async (user) => {
      let uid = user!.uid;
      
      if (this.activatedRoute.snapshot.params['id'])
      {
        uid = this.activatedRoute.snapshot.params['id'];
      }

      await this.customerService
        .getOverview(uid)
        .then(async (x) => {
          if (x.status === FUNCTION_RESULT_STATUS.SUCCESS) {
            this.invoices.set(x.data?.invoices?.data);
            if (this.invoices()!.length > 1)
            {
                const invoice = this.newestInvoice();
                console.log("Latest invoice", invoice);
                this.latest_invoice.set(invoice);
            }
            else
            {
              this.latest_invoice.set(x.data?.invoices?.data[0])
              console.log("Latest invoice", x.data?.invoices?.data);
            }
          }
        })
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
}
